/**
 * Height of the fade band drawn over a scroll container's edge. Tall enough that content
 * dissolves rather than clipping at a line, short enough that it never veils a full row.
 *
 * Sized against the tallest thing the band runs over — a grapheme tile in the deck / Browse
 * grids, ~115pt — at roughly a third of it. The ramp has to read as a gradient across real
 * content, and a band much shorter than this (it was 24) compresses the whole dissolve into a
 * tile's caption line: the falloff is over before the eye can see it fall off, so the row still
 * reads as fully present right up to the boundary.
 *
 * Lives in its own module so `scroll-edge-fade.tsx` exports components only — a file mixing
 * component and constant exports breaks Fast Refresh (`react-refresh/only-export-components`).
 */
export const SCROLL_EDGE_FADE_HEIGHT = 40;
